import { AbstractControl, FormArray, FormGroup } from "@angular/forms";
import { Op } from "@spscommerce/utils";

export function isRequired(control: AbstractControl): boolean {
    if (!control) {
        return false;
    }

    if (control instanceof FormArray) {
        return control.controls.map(isRequired).reduce(Op.OR);
    }

    if (control instanceof FormGroup) {
        return Object.keys(control.controls)
            .map(name => control.controls[name])
            .map(isRequired)
            .reduce(Op.OR);
    }

    if (control.validator) {
        /* There is no API for finding out what validators are attached to
         * a form control in Angular; this is a bit weird but it works */
        const v = control.validator({} as AbstractControl);
        return v && v.required;
    }

    return false;
}
